import fetcher from 'api/fetcher';
import axios from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import {
    setWizardCampaignOptions,
    setWizardCampaignOptionsIsLoading,
    WizardCampaignOptions,
} from 'store/models/campaignCreationWizard';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const fetchWizardCampaignOptions =
    (vacancyId: number, abortSignal?: AbortSignal): AppThunkAction<Promise<void>> =>
    (dispatch) => {
        dispatch(setWizardCampaignOptionsIsLoading(true));
        return fetcher
            .get<unknown, WizardCampaignOptions>(`/api/v1/campaigns/vacancy/${vacancyId}/campaign_options`, {
                signal: abortSignal,
            })
            .then((campaignOptions) => {
                dispatch(setWizardCampaignOptions({ vacancyId, campaignOptions }));
            })
            .catch((error) => {
                if (axios.isCancel(error) || abortSignal?.aborted) {
                    return;
                }
                dispatch(addMagritteNotification(MagritteNotificationName.SomethingWentWrong));
                throw new Error('campaign_options fetch failed');
            })
            .finally(() => {
                dispatch(setWizardCampaignOptionsIsLoading(false));
            });
    };
